<template lang="pug">
div
  el-row
    divider.text-container(label="Visualizar documento")

  visualizar-documentos(
    :documento="documentoAssinatura",
    :bytes="bytes"
  )

  .container
    el-row
      el-button(
        type="default",
        @click="goToListagem",
        name="voltar"
      )
        span.center
          i.fa.fa-chevron-left
          b &nbsp Voltar

</template>

<script>
import Divider from '@/components/AppDivider'
import AppLabel from '@/components/AppLabel'
import cloneDeep from 'lodash/cloneDeep'
import VisualizarDocumentos from '@/screens/assinatura/components/VisualizarDocumentos'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import { mapActions } from 'vuex'

const DOCUMENTO_ASSINATURA_EMPTY = {
  nome: null,
  nomeOriginal: null,
  responsavel: {
    id: null,
    usuario: {
      pessoa: {
        nomeRazaoSocial: null
      }
    }
  },
  tipo: {
    nome: null
  },
  dataEnvio: null,
  dataAssinatura: null
}

export default {
  components: {
    Divider,
    AppLabel,
    VisualizarDocumentos
  },

  mixins: [
    AppNotificacao
  ],

  data () {
    return {
      documentoAssinatura: cloneDeep(DOCUMENTO_ASSINATURA_EMPTY),
      bytes: null
    }
  },

  created () {
    try {
      const { id } = this.$route.query

      if (id) {
        this.findById(id).then(response => {
          this.documentoAssinatura = response
          this.renderPDF()
        })
      }
    } catch (error) {
      this.showNotificacao(
        this.$messages.TIPO_ERROR,
        this.$messages.TITULO_ERROR,
        error.message
      )

      this.goToListagem()
    }
  },

  methods: {
    ...mapActions({
      downloadDocumento: 'documentoAssinatura/download',
      findById: 'documentoAssinatura/findById'
    }),

    async renderPDF () {
      const bytes = await this.downloadDocumento({ fileKey: this.documentoAssinatura.fileKey, id: this.documentoAssinatura.id })
      this.bytes = bytes
    },

    goToListagem () {
      this.$router.go(-1)
    }
  }
}

</script>

<style lang="scss" scoped>
.container {
  display: flex;
  height: 100%;
  flex-direction: column;
  padding: 10px;
}

.text-container >>> .label-divider {
  padding-top: 0px;
}

.container-input {
  margin-right: 20px;
}
</style>



// WEBPACK FOOTER //
// src/screens/assinatura/VisualizarDocumento.vue